"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.set = set;
exports.get = get;
exports.clear = clear;

var _store = _interopRequireDefault(require("store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SELECTED_ORGANISATION_KEY = 'selectedOrganisation';

function set(selectedOrganisationId) {
  _store["default"].set(SELECTED_ORGANISATION_KEY, selectedOrganisationId);
}
/**
 * Get selectedOrganisation from storage
 *
 * @return {selectedOrganisation|null}
 */


function get() {
  return _store["default"].get(SELECTED_ORGANISATION_KEY);
}
/**
 * Clear any stored selectedOrganisationId from storage
 *
 * @return {void}
 */


function clear() {
  _store["default"].remove(SELECTED_ORGANISATION_KEY);
}